import {
  FilterTypeToFilter,
  FilterType,
  FilterTypeSearch,
} from '../common/filters-utils/filters-utils';

export const pipelineSummaryFilters = [
  {
    type: FilterTypeToFilter.Result,
    header: FilterType.result,
  },
  {
    type: FilterTypeToFilter.Apps,
    header: FilterType.apps,
    searchType: FilterTypeSearch.apps,
  },
  {
    type: FilterTypeToFilter.Severity,
    header: FilterType.criticality,
  },
  {
    type: FilterTypeToFilter.EventType,
    header: FilterType.eventType,
  },
  {
    type: FilterTypeToFilter.SourceBranches,
    header: FilterType.sourceBranches,
    searchType: FilterTypeSearch.sourceBranches,
  },
  {
    type: FilterTypeToFilter.JobTriggeredBy,
    header: FilterType.jobTriggeredBy,
    searchType: FilterTypeSearch.jobTriggeredBy,
  },
];
